document.addEventListener('DOMContentLoaded', function () {
  const faqItems = document.querySelectorAll('.faq-item')

  faqItems.forEach((item) => {
    const btn = item.querySelector('.faq-question')
    const buttonIcon = item.querySelector('.faq-icon')
    const answer = item.querySelector('.faq-answer')

    btn.addEventListener('click', function () {
      faqItems.forEach((i) => {
        if (i !== item) {
          i.classList.remove('active')
          i.querySelector('.faq-icon').textContent = '+'
          i.querySelector('.faq-answer').classList.remove('active')
        }
      })

      item.classList.toggle('active')
      if (item.classList.contains('active')) {
        buttonIcon.textContent = '-'
        answer.classList.add('active')
      } else {
        buttonIcon.textContent = '+'
        answer.classList.remove('active')
      }
    })
  })
})
